module.exports = __webpack_public_path__ + "static/media/expired.033509c1.svg";